const Routes = {
  api: {
    v1: {
      admin: {
        usersPath(){
          return `/api/v1/admin/users`
        },
        userEditPath(userId){
          return `/api/v1/admin/users/${userId}/edit`
        },
        userUpdatePath(userId){
          return `/api/v1/admin/users/${userId}/`
        }
      }
    }
  },
  apiV1AdminLocationsPath(){
    return `/api/v1/admin/locations`
  },
  apiV1AdminEditLocationPath(locationId){
    return `/api/v1/admin/locations/${locationId}`
  },
  apiV1AdminUpdateLocationPath(locationId){
    return `/api/v1/admin/locations/${locationId}`
  },
  apiV1AdminDeleteLocationPath(locationId){
    return `/api/v1/admin/locations/${locationId}`
  },
  apiV1LocationsPath(){
    return `/api/v1/locations`
  },
  apiV1SubmitWaitlistEmailPath(){
    return `/api/v1/waitlist/submit`
  }
}

export default Routes
